import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadTaxes = async () => {
  let response = await Axois.get('/taxes').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadTax = async (action) => {
  try {
    switch (action) {
      case 'new':
        return [];
      
      default:
        let response = await Axois.get('/taxes/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}



const useTaxesAPI = () => {
  
  const saveTax = async (data, success, error) => {
    try {
      const response = await Axois.post('/taxes', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('tax_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };

  const updateTax = async (seo, data, success) => {
    try {
      const respnse = await Axois.put('/taxes/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('tax_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { saveTax, updateTax };
}


export default useTaxesAPI;